/** Current signed-in user id for Capacitor resume invalidations (no React context in lifecycle init). */
export const activeUserIdRef = { current: null };
